import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { dismissFlag } from '@helpcenter/flags';
import type { State } from 'state';
import { getFlags } from 'state/selectors/flags';
import FlagGroup from './flag-group';

const selector = createSelector(
	(state: State) => getFlags(state),
	(flags) => ({
		flags,
	}),
);

export default connect(selector, {
	dismissFlagAction: dismissFlag,
})(FlagGroup);
